<template>
  <jet-form-section>
    <template #title>Tax Exempt Information</template>

    <template #description>
      Upload your tax exempt form to request tax exempt status.
    </template>

    <template #form>
      Status: 
      <div v-if="!file && !user.tax_exempt">
        Not Requested
      </div>
      <div v-else-if="!user.tax_exempt">
        Pending Approval - 
        <a :href="file.url" target="_new">Uploaded {{ moment(file.date).format('M/D/YY h:mm A') }}</a>
      </div>
      <div v-else>
        Approved Tax Exempt
        <span v-if="file"> - 
          <a :href="file.url" target="_new">Uploaded {{ moment(file.date).format('M/D/YY h:mm A') }}</a>
        </span>
      </div>

      <jet-action-message :on="form.recentlySuccessful">Saved.</jet-action-message>

      <!-- tax exempt form -->
      <div class="form-group">
        <!-- Profile Photo File Input -->
        <input type="file" hidden ref="document" @change="uploadDocument">

        <jet-button icon="fas fa-file-alt" class="mt-2 mr-2 btn-short" type="button" @click.prevent="selectDocument">
          Upload Document
        </jet-button>

        <jet-input-error :message="form.errors.document" class="mt-2" />
      </div>
    </template>
  </jet-form-section>
</template>

<script>
import JetButton from '@/Jetstream/Button'
import JetFormSection from '@/Jetstream/FormSection'
import JetInput from '@/Jetstream/Input'
import JetInputError from '@/Jetstream/InputError'
import JetLabel from '@/Jetstream/Label'
import JetActionMessage from '@/Jetstream/ActionMessage'
import moment from 'moment'

export default {
  components: {
    JetActionMessage,
    JetButton,
    JetFormSection,
    JetInput,
    JetInputError,
    JetLabel,
  },
  props: {
    user: Object,
    file: Object,
  },
  data() {
    return {
      form: this.$inertia.form({
        _method: 'PUT',
        document: null,
      }),

    }
  },
  created() {
    this.moment = moment;
  },
  methods: {
    uploadDocument() {
      if (this.$refs.document) {
        this.form.document = this.$refs.document.files[0]

        this.form.post(route('user.uploadtaxexempt', this.user), {
          errorBag: 'updateProfileInformation',
          preserveScroll: true
        });
      }
    },
    selectDocument() {
      this.$refs.document.click();
    },
  },
}
</script>
